export default __webpack_public_path__ + "static/media/gpp.998e7440.svg";